const auth = {
  path: '/auth',
  name: 'auth',
  component: require('../../components/Auth/Layout/Layout').default,
  routes: [
    {
      path: '/sign-in',
      name: 'auth.signIn',
      component: require('../../components/Auth/Views/SignIn').default,
    },
    {
      path: '/sign-in-external',
      name: 'auth.signin.external',
      component: require('../../components/Auth/Views/SignInExternal').default,
    },
    {
      path: '/forgot-password',
      name: 'auth.forgotpassword',
      component: require('../../components/Auth/Views/ForgotPassword').default,
    },
    {
      path: '/forgot-password-confirm',
      name: 'auth.forgotpasswordconfirm',
      component: require('../../components/Auth/Views/ForgotPasswordConfirm').default,
    },
    {
      path: '/activation',
      name: 'auth.activation',
      component: require('../../components/Auth/Views/Activation').default,
    },
    {
      path: '/email-confirm',
      name: 'auth.emailconfirm',
      component: require('../../components/Auth/Views/EmailConfirm').default,
    },
    {
      path: '/register',
      name: 'auth.register',
      component: require('../../components/Auth/Views/Register').default,
    },
    {
      path: '/send-email-confirmation',
      name: 'auth.sendemailconfirmation',
      component: require('../../components/Auth/Views/SendEmailConfirmation').default,
    }
  ]
};

export default auth;


// WEBPACK FOOTER //
// ./src/plugins/routes/auth.js